import styled from 'styled-components'
import Title from 'components/Title'

export const StyledTitle = styled(Title)({
  marginBottom: 36,
})
